<template>
    <div class="invoiceInformation">
        <IndexHeader />
        <div class="orgTopHeaderBox">
            <div class="list-bg">
                <div class="bg-content">
                <div class="m-list"><span class="list-font">名单</span></div>
                <div class="m-content">
                    <div class="m-left">
                    <span>参课人数：{{ listData.courseinfo.applyCount }}人</span> <span>满分（{{ listData.courseinfo.credit }}分）</span>
                    <span>课程编号：{{ listData.courseinfo.id }}</span>
                    </div>
                    <div class="m-left">
                    <span class="className" >课程名称：{{ listData.courseinfo.name }}</span>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="list-middle">
            <div class="middle-button">
                <span href="JavaScript:;" target="_blank" class="pi ac bgs" @click="bindScoreAll"> 批量打分</span> 
            </div>
        </div>
        <div class="result">
            <div class="flex listTop">
                <div style="width:100px;flex:unset">
                    <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate"  @change="handleCheckAllChange" >全选</el-checkbox >
                </div>
                <div>姓名</div>
                <div style="width:300px;flex:unset">工作单位</div>
                <div>电话</div>
                <div>得分</div>
                <div>打分</div>
            </div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" >
                <div class="res_content flex" v-for="(item,idx) in listData.list">
                    <div class="res_left"  style="width:100px;flex:unset">
                        <el-checkbox :key="item.userId" :label="item.userId" v-show="item.courseScoreStatus == 0"></el-checkbox>
                    </div>
                    <div class="flex1 res_right">
                        <div class="res_top flex">
                            <div>{{ item.nickName }}</div>
                            <div style="width:300px;flex:unset">{{ item.workName }}</div>
                            <div>{{ item.phonenumber }}</div>
                            <div>{{ item.realScore }}</div>
                            <div>
                                <el-button type="primary" round v-if="item.courseScoreStatus == 0" @click="bindScore(idx)">打&nbsp;&nbsp;分</el-button>
                                <div class="flex dfBox" v-if="item.courseScoreStatus == 2">
                                    <el-input v-model="gradeQuery.score" placeholder="请打分" style="width:80px;margin-right:20px" />
                                    <el-button type="primary" style="margin-right:20px" @click="saveScore(idx)">保存</el-button>
                                    <el-button text @click="closeScore(idx)">取消</el-button >
                                </div>
                            </div>
                        </div>
                        <div class="res_fot">{{ item.feeling }}</div>
                    </div>
                </div>
            </el-checkbox-group>
        </div>
        <!-- 打分浮层 -->
        <div class="mask" v-show="pldfStatus">
            <div class="createSpeaker">
                <div class="topHeader clear">
                    <div class="leftTitle">批量打分</div>
                    <div class="close" @click="pldfStatus = false"><span class="iconfont" ></span></div>
                </div>
                <div class="createBox">
                    <el-form-item label="分数：">
                        <el-input v-model="scoreQuery.score" placeholder="请输入分数" />
                    </el-form-item>
                    <div class="save" @click="saveAll">提交</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
// 首页顶部导航栏
import IndexHeader from "../../components/IndexHeader/TopBar";
import { ref, reactive,getCurrentInstance } from 'vue'
import { useRoute,useRouter } from "vue-router";
import { studyfeelinglist,grade,gradeBatch } from '../../server/jigou/course'

const route = useRoute()
const { proxy } = getCurrentInstance()
const query = reactive({
    id: route.query.id,
    pageSize: 10,
    pageNum: 1
})
const listData = reactive({
    list: {},
    courseinfo: {},
    uidArry:[],
})
const checkAll = ref(false)
const checkedCities = ref([])
const isIndeterminate = ref(false)
const scoreQuery = reactive({
    score:'',  
    userId: [],
    courseId: route.query.id
})
const gradeQuery = reactive({
    score:'',  
    userId: '',
    courseId: route.query.id
})
//获取感悟列表
async function getList(){
    let res = await studyfeelinglist(query)
    if( res != false ){
        listData.list = res.list
        listData.courseinfo = res.courseinfo
        for(let i=0;i<res.list.length;i++){
            if (res.list[i].courseScoreStatus == 0)
            listData.uidArry.push(res.list[i].userId)
        }
    }
}
getList()
const handleCheckAllChange = (val) => {
  checkedCities.value = val ? listData.uidArry : []
  isIndeterminate.value = false
}
const handleCheckedCitiesChange = (value) => {
  const checkedCount = value.length
  checkAll.value = checkedCount === listData.uidArry.length
  isIndeterminate.value = checkedCount > 0 && checkedCount < listData.uidArry.length
}
// const scoreStus = ref(false)
function bindScore(idx){
    // scoreStus.value = true
    listData.list[idx].courseScoreStatus = 2
}
function closeScore(idx){
    // scoreStus.value = false
    listData.list[idx].courseScoreStatus = 0
}
//单独打分
async function saveScore(idx){
    // scoreStus.value = false
    if( !gradeQuery.score ){
        proxy.$modal.msgError("请输入分数");
        return false;
    }
    gradeQuery.userId = listData.list[idx].userId
    let res = await grade(gradeQuery)
    if( res != false ){
        listData.list[idx].courseScoreStatus = 0
        proxy.$modal.msgSuccess("打分成功")
        getList()
    }
}
const pldfStatus = ref(false)
//批量打分
async function saveAll(){
    if( !scoreQuery.score ){
        proxy.$modal.msgError("请输入分数");
        return false;
    }
    let res = await gradeBatch(scoreQuery)
    if ( res != false){
        proxy.$modal.msgSuccess("批量打分成功");
        pldfStatus.value = false
    }
    getList()
}
async function bindScoreAll(){
    console.log('result',checkedCities.value);
    if( !checkedCities.value.length ){
        proxy.$modal.msgSuccess("请选择需要打分的同学");
        return false;
    }
    scoreQuery.userId = checkedCities
    pldfStatus.value = true
   
}


</script>
<style scoped>
    .flex1{
        flex: 1;
    }
    .orgTopHeaderBox{
        margin-top: 64px;
    }
    .result{
        width: 1170px;margin: 0 auto;margin-top: 60px;
    }
    .listTop{
        align-content: center;padding: 20px 40px;
    }
    .el-checkbox{
        height: unset;
    }
    .listTop div{
        flex: 1;
    }
    .res_content{
        padding: 40px;background-color: #fff;border-bottom: 1px solid #ccc;align-items: flex-start;
    }
    .res_top{
        color: #333;font-size: 14px;align-items: center;
    }
    .res_top div{
        flex: 1;
    }
    .res_fot{
        font-size: 14px;color: #333;margin-top: 20px;line-height: 28px;
    }
    .res_content >>>.el-checkbox__label{
        font-size: 0px;
    }
    .createSpeaker{
        height: 300px;
    }
    .createSpeaker .createBox{
        height: 100px;
        box-shadow:none;
        background: none;
    }
    .createBox{
        margin-top: 40px;
    }
    .createBox >>> .el-form-item{
       align-items: center;justify-content: center;
    }
    .createBox >>> .el-form-item__label{
        line-height: 32px;
    }
</style>